// extracted by mini-css-extract-plugin
module.exports = {"textarea":"styles_textarea__1A_pL"};